import React from 'react'

type Props = {
    children: React.ReactNode
}

export default function Alert(props: Props) {
    return (
        <div className='my-5 border border-gray-200 shadow rounded px-4 py-5 bg-gray-50 text-blue-700 text-sm'>
            {props.children}
        </div>
    )
}
